import { Card, Col, Empty, Form, Input, Row, Space, Button } from "antd";

const { TextArea } = Input;

export const UbicacionCard = ({ titulo, icono, datos, onVerMapa, onChange, iconoAccion, iconoVacio, textoVacio }) => {
  const handleFieldChange = (field, value) => {
    if (onChange && datos) onChange({ ...datos, [field]: value });
  };

  return (
    <Card
      size="small"
      title={
        <Space>
          {icono}
          <span>{titulo}</span>
        </Space>
      }
    >
      {datos ? (
        <Form size="small" layout="vertical" style={{ marginBottom: 12 }}>
          <Form.Item label="Dirección" style={{ marginBottom: 8 }}>
            <TextArea
              value={datos.direccionCompleta}
              onChange={(e) => handleFieldChange("direccionCompleta", e.target.value)}
              rows={2}
              placeholder="Dirección completa"
            />
          </Form.Item>
          <Row gutter={8}>
            <Col span={12}>
              <Form.Item label="Estado" style={{ marginBottom: 8 }}>
                <Input
                  value={datos.estado}
                  onChange={(e) => handleFieldChange("estado", e.target.value)}
                  placeholder="Estado"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Municipio" style={{ marginBottom: 8 }}>
                <Input
                  value={datos.municipio}
                  onChange={(e) => handleFieldChange("municipio", e.target.value)}
                  placeholder="Municipio"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col span={12}>
              <Form.Item label="CP" style={{ marginBottom: 8 }}>
                <Input
                  value={datos.cp}
                  onChange={(e) => handleFieldChange("cp", e.target.value)}
                  placeholder="Código Postal"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Coordenadas" style={{ marginBottom: 8 }}>
                <Input value={`${datos.lat}, ${datos.lng}`} disabled style={{ color: "#666" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={textoVacio} style={{ margin: "12px 0" }} />
      )}
      <Button type="primary" icon={datos ? iconoAccion : iconoVacio} onClick={onVerMapa} block>
        {datos ? "Cambiar Ubicación" : "Seleccionar en Mapa"}
      </Button>
    </Card>
  );
};
